<form [formGroup]="farmForm" (ngSubmit)="addFarm()">
    <div class="flex-col">
        <div class="flex-1">
            <h2 style="font-weight: bold; font-size: medium; margin-bottom: -0.5em">{{ 'ADD-FARM-DIALOG.FARM-NAME' | translate }}</h2>
            <br />
            <mat-form-field style="width: 100%; margin-bottom: 10px;" appearance="outline">
                <input matInput type="text" placeholder="Farm name" formControlName="farmName">
                <mat-error *ngFor="let validation of validation_messages.farmName">
                    <mat-error class="error-message" *ngIf="farmForm.get('farmName').hasError(validation.type) && 
            (farmForm.get('farmName').dirty || farmForm.get('farmName').touched)">
                        {{validation.message}}
                    </mat-error>
                </mat-error>
            </mat-form-field>
            <br />
            <h2 style="font-weight: bold; font-size: medium; margin-bottom: -0.5em;">{{ 'ADD-FARM-DIALOG.COUNTRY' | translate }}</h2>
            <br />
            <mat-form-field style="width: 100%;" appearance="outline">
                <mat-select formControlName="country">
                    <div class="scrollable-container">
                        <div class="scrollable">
                            <mat-option *ngFor="let country of countries | orderBy: 'name'" [value]="country">
                                {{country.name}}
                            </mat-option>
                        </div>
                    </div>
                </mat-select>
                <mat-error *ngFor="let validation of validation_messages.country">
                    <mat-error class="error-message" *ngIf="farmForm.get('country').hasError(validation.type) && 
                        (farmForm.get('country').dirty || farmForm.get('country').touched)">
                        {{validation.message}}
                    </mat-error>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="flex-1" *ngIf="farmForm.get('country')?.value">
            <mat-label style="font-weight: bold; font-size: medium;">{{ 'ADD-FARM-DIALOG.PROVINCE' | translate }}</mat-label>
            <br />
            <mat-form-field style="width: 100%;" appearance="outline">
                <mat-select formControlName="province">
                    <div class="scrollable-container">
                        <div class="scrollable">
                            <mat-option *ngFor="let province of farmForm.get('country')?.value?.provinces | orderBy: 'name'"
                                [value]="province.id">
                                {{province.name}}
                            </mat-option>
                        </div>
                    </div>
                </mat-select>
                <mat-error *ngFor="let validation of validation_messages.province">
                    <mat-error class="error-message" *ngIf="farmForm.get('province').hasError(validation.type) && 
                        (farmForm.get('province').dirty || farmForm.get('province').touched)">
                        {{validation.message}}
                    </mat-error>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="flex-1 flex-row">
            <button mat-flat-button style="width: 40%;" (click)="cancel()" type="button" class="cancel-add-farm">{{ 'ADD-FARM-DIALOG.CANCEL' |
                translate }}</button>
            <button mat-flat-button style="width: 40%;" type="submit" class="buttons add-btn" [disabled]="!farmForm.valid">{{ 'ADD-FARM-DIALOG.ADD-FARM' |
                translate }}</button>
        </div>
    </div>
</form>
